import React, { useContext, useState } from 'react';

import './styles.css';

import P from 'prop-types';
import { LabelForm } from '../LabelForm';
import { InputText } from '../InputText';
import { Button } from '../Button';
import { Logar } from '../../utils/api/api';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize, SaveUser } from '../../utils/utils';
import { Modal } from '../Modal';
import { LoginRodape } from '../LoginRodape';

export const Login = ({ handleModal, handleClose }) => {
  const { dadosApp, setUser, setEnderecos } = useContext(GlobalContext);
  const [dados, setDados] = useState({});
  const [modalSms, setModalSms] = useState({ display: 'none', cliente: {} });
  const [modalLoading, setModalLoading] = useState('none');

  const tratarDadosEnvio = (dadosEnvio) => {
    let retorno = { ...dadosEnvio };
    retorno['idloja'] = dadosApp.IdLoja;
    return retorno;
  };

  const showHideModalLoading = () => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  };

  async function handleLogin(showWelcome = true) {
    showHideModalLoading();
    const response = await Logar(tratarDadosEnvio(dados));
    setModalLoading('none');
    if (response.data.Retorno.status == 0) {
      let usuario = { ...response.data.Usuario, senha: dados.senha, email: dados.email };

      if (parseInt(usuario.ativo) == 0) {
        showHideSmsModal(usuario);
        return;
      }

      SaveUser(dadosApp.IdLoja, usuario, setUser);
      setModalSms({ display: 'none' });
      setEnderecos(response.data.Enderecos);
      handleClose();
      showWelcome ? toast.success('Olá ' + Capitalize(usuario.nome_completo) + '!') : false;
    } else {
      toast.error('Erro na tentativa de Login: ' + response.data.Retorno.msg, { containerId: 'modalToast' });
    }
    return;
  }

  const showHideSmsModal = (usuario) => {
    let data = {
      display: modalSms.display == 'none' ? 'block' : 'none',
      cliente: usuario,
      closeCadastro: () => {
        handleLogin(false);
        handleClose();
      },
    };
    setModalSms({ ...data });
  };

  const handleInputs = (event) => {
    let target = event.target;
    let value = target.type == 'checkbox' ? target.checked : target.value;
    dados[target.name] = value;
    setDados({ ...dados });
  };

  return (
    <div style={{ margin: 10, marginTop: 20 }}>
      <div className={'modal-content-dialog cardShadow'} style={{ borderTop: 'none', padding: 25, minWidth: 280 }}>
        <form>
          <div className="form-group">
            <LabelForm text={'Email'} labelFor={'email'} />
            <InputText
              type={'text'}
              placeHolder={''}
              className={'form-control'}
              name={'email'}
              onChange={handleInputs}
              value={dados.email}
            />
            <i className="material-icons">mail_outline</i>
          </div>
          <div className="form-group" style={{ marginBottom: '25px' }}>
            <LabelForm text={'Senha'} labelFor={'senha'} />
            <InputText
              type={'password'}
              placeHolder={''}
              className={'form-control'}
              name={'senha'}
              onChange={handleInputs}
              value={dados.senha}
            />
            <i className="material-icons">lock_outline</i>
          </div>
          <Button text="Entrar" className={'btn_1 btnGradient btn-width-full'} onClick={handleLogin} />
          <div className={'clearfix-checkbox'}></div>
          {/* <div className="info-green" style={{ marginTop: 30, marginBottom: 0 }}>
            <a href="#" onClick={() => handleModal('RECUPERAR_SENHA', 'Esqueceu a Senha?')}>
              Esqueceu a senha?
            </a>
          </div> */}
        </form>

        <div className={'clearfix-checkbox'}></div>

        {modalSms.display == 'block' && (
          <Modal
            param={modalSms}
            page="SMS"
            customPosition="modal-position-bottom"
            title="Autentique sua conta"
            visibility={modalSms.display}
            isFooter={false}
            btnOnClickClose={showHideSmsModal}
          />
        )}

        {modalLoading == 'block' && (
          <Modal
            title=""
            isFooter={false}
            visibility={modalLoading}
            param={{ msg: 'Aguarde...' }}
            page="LOADING"
            customPosition="loading-modal"
          />
        )}
      </div>
      <div className="info-green" style={{ margin: 20 }}>
        <a href="#" onClick={() => handleModal('RECUPERAR_SENHA', 'Esqueceu a Senha?')}>
          Esqueceu a senha?
        </a>
      </div>

      <LoginRodape handleBodyModal={() => handleModal('MEUS_DADOS', 'Cadastro')} />
    </div>
  );
};

Login.propTypes = {
  handleModal: P.func,
  handleClose: P.func,
};
